

import Vue from "vue"; 
const requireContext = require.context("./", false, /.*\.vue$/);
const coms = requireContext.keys().map(file => [file.replace(/(^.\/)|(\.vue$)/g, ""), requireContext(file)]).reduce((components, [name, component]) => { 
    components[name] = component.default || component;
    return {
        ...components,
        [name]: component
    }
  }, {});  
for (let com in coms){
    Vue.component(coms[com].default.name, coms[com].default) 
}